import React from 'react';
import classes from './KeywordsFilter.module.css';

const keywordsFilter = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);
  return (
    <div className={containerClasses.join(' ')}>
      <input className={classes.KeywordsInput} value={props.keywords} onChange={props.changed} placeholder="Enter keyword(s) separated by commas." />
      <div className={classes.Controls}>
        <p onClick={props.clear}>Clear</p>
        <p onClick={props.submit}>SAVE</p>
      </div>
    </div>
  );
};

export default keywordsFilter;
